
document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('.testimonial-v2')
  if (!section) return

  const slides = section.querySelectorAll('.testimonial-v2__slide')
  const counter = section.querySelector('#testimonialCounter')
  const navButton = section.querySelector('#testimonialNav')

  let currentIndex = 0
  let direction = 'forward'
  const totalSlides = slides.length

  function updateSlider() {
    slides.forEach(slide =>
      slide.classList.remove('testimonial-v2__slide--active')
    )

    slides[currentIndex].classList.add('testimonial-v2__slide--active')
    counter.textContent = `${currentIndex + 1} / ${totalSlides}`

    navButton.classList.toggle(
      'testimonial-v2__nav--backward',
      direction === 'backward'
    )
  }

  function goNext() {
    if (direction === 'forward') {
      currentIndex++
      if (currentIndex === totalSlides - 1) direction = 'backward'
    } else {
      currentIndex--
      if (currentIndex === 0) direction = 'forward'
    }
    updateSlider()
  }

  /* =========================
     MANUAL NAV ONLY
  ========================== */
  navButton.addEventListener('click', goNext)

  updateSlider()
})
